import { queryFeatures } from '@/features/features/data';
import type { GridQueryInput } from '@/ui/composites/grid/gridUtils';
import type { FeatureDto, QueryResult } from '@flowqa/shared';

export const fetchFeaturesGrid = async (
  projectId?: string | null,
  organisationId?: string | null,
  input?: GridQueryInput,
): Promise<QueryResult<FeatureDto>> => {
  return await queryFeatures(projectId ?? undefined, organisationId ?? undefined, input);
};
